interface ISidebarSectionProps {
  title: string;
  children: React.ReactNode;
}

export const SidebarSection = ({ title, children }: ISidebarSectionProps) => {
  return (
    <div
      className="
      divide-y
      [@media(max-height:1023px)]:my-1
      [@media(min-height:1024px)]:my-2"
    >
      <span className="text-gray-400 text-sm uppercase">{title}</span>
      <div className="py-1 xxl:mt-1"></div>
      {children}
    </div>
  );
};
